import { getLocalUserInfo } from "./authHelper";
import { isNumber } from "./is";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const isUserLoggedIn = () => !!Object.keys(getUserData()).length;

export const getAccessToken = localStorage.getItem("accessToken") || "";

export const getUserData = () => {
    const userData = localStorage.getItem("userData") || "";
    return userData ? JSON.parse(userData) : {};
};

export const getCookie = (key) => {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
};

export const removeCookie = (key) => {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};

// HTTP query params set to send in API call
export const setHttpParams = (params) => {
    // delete key, if key has no value or value = null
    Object.keys(params).forEach(
        (key) =>
            (params[key] == null || params[key] == "") &&
            typeof params[key] !== "boolean" &&
            delete params[key]
    );

    let length = Object.keys(params).length;
    let param = "";
    for (const [key, value] of Object.entries(params)) {
        param = param + `${key}=${value}`;
        length = length - 1;
        param = length ? param + "&" : param;
    }
    return param;
};

// format date to YYYY-MM-DD format
export const formatDate = (dateTime) => {
    let date = new Date(dateTime);
    return date.toISOString().substring(0, 10);
};

// date different
export const dateDiff = (endDate, startDate, diffIn = "days") => {
    let end = new Date(endDate);
    let start = new Date(startDate);
    let dateDiff = 0;
    switch (diffIn) {
        case "days":
            dateDiff = Math.ceil(end - start) * 1000 * 60 * 60 * 24;
            break;
        case "mins":
            dateDiff = Math.ceil(end - start) * 1000 * 60 * 60;
            break;
        default:
            dateDiff = 0;
    }
    return dateDiff;
};

/**
 * Check submit button should remain disabled or not
 * @param formInput
 * @returns {boolean}
 */
export const checkDisableButton = (formInput) => {
    for (const property in formInput) {
        if (!formInput[property].isValid) {
            return true;
        }
    }
    return false;
};

export const getFormattedDate = (date, type = "date", format = "") => {
    if (format === "") {
        switch (String(type).toLowerCase()) {
            case "datetime24":
                format = "YYYY-MM-DD HH:mm:ss";
                break;
            case "datetimeampm":
                format = "DD-MM-YYYY HH:mm:ss a";
                break;
            case "datetime-ampm12-with-slash":
                format = "DD/MM/YYYY hh:mm:ss A";
                break;
            case "date-with-slash":
                format = "DD/MM/YYYY";
                break;
            case "iso":
                format = "YYYY-MM-DDTHH:mm:ssZ";
                break;
            case "dateiso":
                format = "YYYY-MM-DD";
                break;
            case "bdtickets":
                format = "DD MMM YYYY";
                break;
            case "bdtickets-default":
                format = "DD-MM-YYYY hh:mm A";
                break;
            case "onlytime12":
                format = "hh:mm:ss A";
                break;
            case "onlytime12withoutseconds":
                format = "hh:mm A";
                break;
            case "onlytime24":
                format = "hh:mm:ss";
                break;
            case "onlytime24withoutseconds":
                format = "HH:mm";
                break;
            case "default":
                format = "DD-MM-YYYY";
                break;
            default:
                format = "DD-MM-YYYY";
                break;
        }
    }
    // console.log("🚀 ~ getFormattedDate ~ format:", format);

    return dayjs(date).format(format);
};

export const convertToBase64 = (file) => {
    if (!file) {
        return;
    }
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const objectRemoveEmptyString = (object) => {
    const keys = ["schedule_start", "schedule_end"];
    Object.entries(object).forEach(([key, value]) => {
        if (value && typeof value === "object") objectRemoveEmptyString(value);
        if (keys.includes(key)) {
            // console.log(key);
        } else if (
            (value &&
                typeof value === "object" &&
                !Object.keys(value).length) ||
            value === null ||
            value === undefined ||
            value.length === 0
        ) {
            if (Array.isArray(object)) object.splice(key, 1);
            else delete object[key];
        }
    });
    return object;
};

// if there is hyphen or underscore => separate word & uppercase 1st letter
export const separateWord = (word) => {
    const words = word.split(/[-_]/); // digital-services =>
    let title = "";
    words.forEach((item, idx) => {
        title = title + item.charAt(0).toUpperCase() + item.slice(1); //   =>
        title = idx < words.length - 1 ? title + " " : title;
    });
    return title;
};

// from page & section create title for popular service pages
// digital-services, gaming-nation =>   Gaming Nation
export const getPopularServiceName = (page, section) => {
    page = separateWord(page);
    section = separateWord(section);
    // LATER:  switch(page) {
    //     case ''
    // }
    return page
        .concat(" ", section)
        .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
};

/**
 * Update the config name to match with fomConfig key, called from getFormConfigName() & updateSectionName()
 * if isSection true, just concat the words, for section name; else lowercase the 1st char of 1st word
 * Ex: digital-services => digitalServices
 *
 * @param word
 * @param isSection
 * @returns {string}
 */
const updateConfigName = (word, isSection = true) => {
    const words = word.split(/[-_]/); // digital-services =>
    let title = "";

    if (isSection) {
        words.forEach((item, idx) => {
            title = title + item.charAt(0).toUpperCase() + item.slice(1); //   =>
        });
    } else {
        words.forEach((item, idx) => {
            title = !idx
                ? title + item
                : title + item.charAt(0).toUpperCase() + item.slice(1); //   =>
        });
    }

    return title;
};

/**
 * Called for updating section for some cased for form config name
 * @param section
 * @returns {string}
 */
const updateSectionName = (section) => {
    switch (section) {
        case "refill-banner":
            section = "banner";
            break;
        case "refill-other-banner":
            section = "other-banner";
            break;
        default:
            break;
    }
    return updateConfigName(section);
};

/**
 * Get config name for config based UI: popular services, shortcuts, banners related
 * @param page => digital-services
 * @param section => gaming-nation
 * Ex: convert from page & section to => digitalServicesGamingNation
 * */
export const getFormConfigName = (page, section) => {
    const originalPage = page;
    page = updateConfigName(page, false);

    switch (originalPage) {
        case "dashboard":
        case "usage-summary":
            section = updateConfigName(section);
            break;
        default:
            section = updateSectionName(section);
            break;
    }
    return page.concat(section);
};

// from page & section create title for popular service pages
export const getSettingsName = (key) => {
    key = separateWord(key);
    return key.replace(/\w\S*/g, (w) =>
        w.replace(/^\w/, (c) => c.toUpperCase())
    );
};

export const renameKeys = (obj, newKeys) => {
    const keyValues = Object.keys(obj).map((key) => {
        const newKey = newKeys[key] || key;
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
};

export const isObject = (v) => v && typeof v === "object";

export const getObjectKeyDifference = (a, b) => {
    return Object.assign(
        ...Array.from(new Set([...Object.keys(a), ...Object.keys(b)]), (k) => ({
            [k]:
                isObject(a[k]) && isObject(b[k])
                    ? getObjectKeyDifference(a[k], b[k])
                    : a[k] === b[k],
        }))
    );
};
export const removeItemOnce = (arr, value) => {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
};

export const isSameObject = (obj1, obj2) => {
    obj1 = objectRemoveEmptyString(obj1);
    obj2 = objectRemoveEmptyString(obj2);
    if (Object.keys(obj1).length === Object.keys(obj2).length) {
        return Object.keys(obj1).every(
            (key) => obj2.hasOwnProperty(key) && obj2[key] === obj1[key]
        );
    }
    return false;
};

export const extractParamFromUrl = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
};

const reloadUrl = (urlPath) => {
    window.history.pushState({ html: "", pageTitle: "" }, "", urlPath);
};
export const setUpdatedUrl = (paramsStr = "") => {
    const url = window.location.href;
    const queryParamFirstOccur = url.indexOf("?");
    if (queryParamFirstOccur >= 0) {
        const baseUrl = url.substring(0, queryParamFirstOccur);
        reloadUrl(`${baseUrl}?${paramsStr}`);
    } else {
        reloadUrl(`${url}?${paramsStr}`);
    }
};

export const trackCardValidation = (inputs = {}) => {
    let errorTrack = {};
    if (!inputs?.type || !inputs.type.length) {
        errorTrack = { ...errorTrack, ...{ type: { validated: false } } };
    }
    if (!inputs?.status || !inputs.status.length) {
        errorTrack = { ...errorTrack, ...{ status: { validated: false } } };
    }
    if (!inputs?.title || !Object.keys(inputs.title).length) {
        errorTrack = { ...errorTrack, ...{ title: { validated: false } } };
    }
    if (!inputs?.images || !Object.keys(inputs.images).length) {
        errorTrack = { ...errorTrack, ...{ images: { validated: false } } };
    }

    return errorTrack;
};

/**
 * To check users ability
 * @param permission
 * @returns
 */
export const hasPermission = (permission = {}) => {
    const user = getLocalUserInfo();
    return user.permissions ? user.permissions.includes(permission) : false;
};

/**
 * To check users role
 * @param role
 * @returns
 */
export const hasRole = (role = {}) => {
    const user = getLocalUserInfo();
    return user.roles ? user.roles == role : false;
};

/**
 * Check any of first array item, exists in second array
 *
 * @param arr1
 * @param arr2
 * @returns
 */

export const existsInSecondArray = (arr1, arr2) => {
    return arr1.some((item) => arr2.includes(item));
};
const removeBackSlash = (str) => {
    if (str && str[0] == "/") {
        return str.substr(1);
    }
    return str;
};
export const getImage = (image = "") => {
    let icon = "";
    if (image) {
        icon =
            image?.indexOf("https://online.test.dtac.co.th") === 0 ||
            image?.indexOf("https://dtacapp-static-dev.dtac.co.th") === 0
                ? image
                : image
                ? image?.indexOf("http://localhost") >= 0
                    ? removeBackSlash(image)
                    : process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL + image
                : undefined;
    }
    return icon;
};
export const formatHoursInto24Format = (
    date,
    timeDateDelimiter = " ",
    calAmPmFormat = true
) => {
    let dateFormat = "";
    try {
        dateFormat = new Date(date);
        let month = (dateFormat.getMonth() + 1).toString();
        month = month.length == 1 ? `0${month}` : month;
        let day = (dateFormat.getDate() + 1).toString();
        day = day.length == 1 ? `0${day}` : day;
        dateFormat = `${dateFormat.getFullYear()}-
        ${month}-${day}T
        ${
            dateFormat.getHours() < 12 && calAmPmFormat
                ? dateFormat.getHours() + 12
                : dateFormat.getHours()
        }:
                ${dateFormat.getMinutes()}:
                ${dateFormat.getSeconds()}`;
        dateFormat = dateFormat.replace(/\s/gi, "");
        return dateFormat.replace("T", timeDateDelimiter);
    } catch (error) {
        return dateFormat;
    }
};

export const validateCampaignCards = (inputs = {}) => {
    let errorTrack = {};
    if (!inputs?.status || !inputs.status.length) {
        errorTrack = { ...errorTrack, ...{ status: { validated: false } } };
    }
    if (!inputs?.title || !Object.keys(inputs.title).length) {
        errorTrack = { ...errorTrack, ...{ title: { validated: false } } };
    }
    if (!inputs?.images || !Object.keys(inputs.images).length) {
        errorTrack = { ...errorTrack, ...{ images: { validated: false } } };
    }
    if (!inputs?.summary || !Object.keys(inputs.summary).length) {
        errorTrack = { ...errorTrack, ...{ summary: { validated: false } } };
    }
    if (!inputs?.description || !Object.keys(inputs.description).length) {
        errorTrack = {
            ...errorTrack,
            ...{ description: { validated: false } },
        };
    }
    if (!inputs?.detail_images || !Object.keys(inputs.detail_images).length) {
        errorTrack = {
            ...errorTrack,
            ...{ detail_images: { validated: false } },
        };
    }

    return errorTrack;
};

export const numberFormat = (number, decimal = 2) =>
    new Intl.NumberFormat("th", {
        minimumFractionDigits: decimal,
    }).format(number);

export const getStaticContentBaseUrl = () => {
    return process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL;
};

/**
 * Convert string to slug
 */
export const stringToSlug = (str) => {
    return str
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, "") // Remove special characters
        .replace(/-+/g, "-"); // Replace multiple hyphens with a single hyphen
};

export function countOnlineSeats(data) {
    return data.reduce(
        (count, item) => count + (item.is_online === true ? 1 : 0),
        0
    );
}

export function countCounterSeats(data) {
    return data.reduce(
        (count, item) => count + (item.is_counter === true ? 1 : 0),
        0
    );
}

export const containRoleTypes = (roles, type = null) => {
    return type
        ? roles?.filter(
              (item) => item?.value?.substring(0, type.length) === type
          )
        : roles;
};
// Shall Discuss this with Al-amin vaiya
export async function generateDeviceId() {
    const deviceInfo = [
        navigator?.userAgentData?.platform || "unknown",
        navigator.language,
        screen.width,
        screen.height,
        screen.colorDepth,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        navigator.hardwareConcurrency,
        navigator.deviceMemory,
    ].join("");
    const encoder = new TextEncoder();
    const data = encoder.encode(deviceInfo);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
}

// Function to set a cookie
export function setCookieData(name, value, seconds) {
    var expires = "";
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie
export function getCookieData(name) {
    var nameEQ = name + "=";
    var cookiesArray = document.cookie.split(";");
    for (var i = 0; i < cookiesArray.length; i++) {
        var cookie = cookiesArray[i];
        while (cookie.charAt(0) == " ")
            cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) == 0)
            return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
}

export function removeCookieData(name) {
    setCookieData(name, "", -1); // Set the cookie with an expired date
}

export function convertValuesToKeysAsString(obj) {
    const result = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = key;
        }
    }

    return result;
}

export function covertTimeTo12Hourformat(
    timeString = "00:00:00",
    format = "hh:mm:ss A"
) {
    try {
        return dayjs(timeString, "HH:mm:ss").format(format);
    } catch (e) {}

    return timeString;
}

export function forwardOrBackwardDate(
    day = 0,
    isForward = true,
    date = new Date(),
    format = "YYYY-MM-DD"
) {
    try {
        const specificDate = dayjs(date);

        let finalDate = "";

        if (isForward) {
            finalDate = specificDate.add(day, "day");
        } else {
            finalDate = specificDate.subtract(day, "day");
        }

        return new Date(finalDate.format(format));
    } catch (e) {}

    return date;
}

export default function getHour(datetime = new Date()) {
    try {
        return dayjs(datetime).hour();
    } catch (e) {}

    return null;
}

export function getCurrencySymbol() {
    const currencySign = (0)
        .toLocaleString("bn-BD", {
            style: "currency",
            currency: "BDT",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
        .replace(/0/g, "")
        .trim();
    return currencySign.slice(0, 0) + currencySign.slice(0 + 1);
}

export function generateRandomString(length) {
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"; // Characters to use in the random string
    return Array.from({ length }, () =>
        characters.charAt(Math.floor(Math.random() * characters.length))
    ).join("");
}

export function addTime(
    value = 0,
    type = "minute",
    dateTime = null,
    format = "YYYY-MM-DD HH:mm"
) {
    try {
        dateTime = dayjs(dateTime || new Date());
        return dateTime.add(value, type).format(format);
    } catch (e) {}

    return null;
}

export function generateRandomPassword(length = 8) {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";

    // Ensure at least one number and one special character
    let password = "";
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += specialChars[Math.floor(Math.random() * specialChars.length)];

    // Fill the rest of the password with random characters
    const allChars = letters + numbers + specialChars;
    for (let i = 2; i < length; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    // Shuffle the password to randomize placement of number and special character
    password = password
        .split("")
        .sort(() => 0.5 - Math.random())
        .join("");

    return password;
}

export const formatCurrency = (value, locale = "en-BD") => {
    if (!value) return "৳ 0";
    return !isNaN(value) ? `৳ ${parseFloat(value).toLocaleString(locale)}` : "";
};

export const formatCurrencyWithoutSymbol = (value, locale = "en-BD") => {
    if (!value) return "0";
    return !isNaN(value) ? `${parseFloat(value).toLocaleString(locale)}` : "";
};

export const convertFirstCharacterToUpperCase = (text = "") => {
    if (typeof text == "string" && text.length) {
        return `${text.charAt(0).toUpperCase()}${text.slice(1, text.length)}`;
    }

    return text;
};

export const statusText = (text = "") => {
    return String(text || "")
        .replace(/_/g, " ")
        ?.toUpperCase();
};

export const convertToReadableSentence = (str) => {
    // Replace underscores with spaces and split the string into words
    let formattedStr = str.replace(/_/g, " ");

    // Lower case all the characters first
    formattedStr = formattedStr.toLowerCase();

    // Capitalize the first letter of the sentence
    formattedStr = formattedStr.charAt(0).toUpperCase() + formattedStr.slice(1);

    return formattedStr;
};

export const getTimeStamp = (dateTime = new Date()) => {
    try {
        return dateTime.getTime();
    } catch (e) {}
    return null;
};

export function getFormattedTime(
    timeString = "00:00:00",
    format = "hh:mm:ss A",
    currentFormat = "HH:mm:ss"
) {
    try {
        return dayjs(timeString, currentFormat).format(format);
    } catch (e) {}

    return timeString;
}

export const getAPIErrorMessage = (error, code = 400, prefixMessage = "") => {
    let message = `Something went wrong!`;
    if (prefixMessage) {
        message = `${prefixMessage} ${message}`;
    }

    try {
        const errorCode = error.data?.code;
        if (errorCode >= code && errorCode < code + 100) {
            message =
                error.data.error?.message || error.data.error?.title || message;
        }
    } catch (e) {}

    return message;
};

export function enableHeaderCache(cache) {
    return cache
        ? undefined
        : {
              headers: {
                  "Cache-Control": "no-cache, private",
              },
          };
}

export function getDateTimeWithTimeZone(
    time,
    timezone,
    format = "DD-MM-YYYY hh:mm A"
) {
    const utcTime = dayjs.utc(time);
    const localTime = utcTime.add(timezone || 0, "hour");
    return localTime.format(format);
}

export const generateRandomId = (length = 9) => {
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomId = "";
    for (let i = 0; i < length; i++) {
        randomId += characters.charAt(
            Math.floor(Math.random() * characters.length)
        );
    }
    return randomId;
};

export function convertToTitleCase(str) {
    return str
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
